// MST
import { Instance, SnapshotOut, types, applySnapshot, addMiddleware } from 'mobx-state-tree'

// Models
import { webpageModels } from 'models/webpage'
import { masterModels } from 'models/back-office/master'
import { personalDataModels } from 'models/back-office/personal-data'
import { authModels } from 'models/auth'
import { otpModels } from 'models/back-office/otp'
import { userModels } from 'models/back-office/user'
import { etcModels } from 'models/etc'
import { qaModels } from 'models/back-office/qa'
import { userAccessModels } from 'models/back-office/user-access'
import { contentManagementModels } from 'models/back-office/content-management'
import { setSelfAssessmentFormModels } from 'models/back-office/set-self-assessment-form'
import { assessmentModels } from 'models/back-office/assessment'

export const RootStoreModel = types
  .model('RootStore')
  .props({
    ...etcModels,
    ...authModels,
    ...otpModels,
    ...userAccessModels,
    ...personalDataModels,
    ...userModels,
    ...webpageModels,
    ...masterModels,
    ...qaModels,
    ...contentManagementModels,
    ...setSelfAssessmentFormModels,
    ...assessmentModels,
  })
  .actions(self => {
    addMiddleware(self, (call, next, abort) => {
      // Do anything with the middleware

      next(call)
    })

    return {
      reset: () => {
        applySnapshot(self, {})
      },
    }
  })

/**
 * The RootStore instance.
 */
export interface RootStore extends Instance<typeof RootStoreModel> {}

/**
 * The data of a RootStore.
 */
export interface RootStoreSnapshot extends SnapshotOut<typeof RootStoreModel> {}
